var Codec = require('io/codec');
var ErrorReport = require('services/error-report');

var serialiser = {
    read : function(input) {
        var message = Codec.readString(input);
        var line = Codec.readInt32(input);
        var column = Codec.readInt32(input);

        return new ErrorReport(message, line, column);
    },
    write : function(output, value) {
        Codec.writeString(output, value.message);
        Codec.writeInt32(output, value.line);
        Codec.writeInt32(output, value.column);
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/error-report-serialiser.js
// module id = 208
// module chunks = 0